import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

const ENDPOINT = '/iMetalStud/';

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.L,
    W: input.W,
    addedWeight: input.addedWeight,
    supports: input.support,
    sectionName: input.sectionName,
    numStuds: input.numStuds,
    restraintLength: input.restraintLength,
    axialLoad: input.axialLoad,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>(ENDPOINT, mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeCancellable };
